module.exports = __webpack_public_path__ + "static/media/2.fc9a50b1.svg";